"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Element_1 = require("./Element");
var Node = /** @class */ (function (_super) {
    tslib_1.__extends(Node, _super);
    function Node(type, componentCode) {
        var _this = _super.call(this) || this;
        _this.data = null;
        _this.XO_type = type;
        _this.componentCode = componentCode;
        return _this;
    }
    Object.defineProperty(Node.prototype, "nodeId", {
        get: function () {
            if (!this._nodeId) {
                this._nodeId = this.XO_type + "-" + this.id;
            }
            return this._nodeId;
        },
        enumerable: true,
        configurable: true
    });
    Node.prototype.getNodeSvg = function () {
        var result = (this.svgNode.width <= 100
            ? "<ellipse\n                cx=\"" + (this.svgNode.width + 1) + "\"\n                cy=\"" + this.svgNode.height / 2 + "\"\n                rx=\"" + this.svgNode.width + "\"\n                ry=\"" + this.svgNode.height / 2 + "\"\n                fill=\"white\"\n                style=\"stroke:purple;stroke-width:2;\"\n            />"
            : "<ellipse\"\n                cx=\"" + (this.svgNode.width * 2 / 3 + 1) + "\"\n                cy=\"" + this.svgNode.height / 2 + "\"\n                rx=\"" + this.svgNode.width * 2 / 3 + "\"\n                ry=\"" + this.svgNode.height / 2 + "\"\n                fill=\"white\"\n                style=\"stroke:purple;stroke-width:2;\"\n            />")
            + ("<text alignment-baseline=\"central\" x=\"" + this.svgNode.width / 6 + "\" y=\"" + this.svgNode.height / 2 + "\">" + encodeHTML(this.label) + "</text>");
        return result;
    };
    return Node;
}(Element_1.Element));
exports.Node = Node;
function encodeHTML(str) {
    return toUTF8Array(str).map(function (s) {
        return String.fromCharCode(s);
    }).join("");
}
exports.encodeHTML = encodeHTML;
function toUTF8Array(str) {
    var utf8 = [];
    for (var i = 0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80)
            utf8.push(charcode);
        else if (charcode < 0x800) {
            utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
            utf8.push(0xe0 | (charcode >> 12), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
        }
        // surrogate pair
        else {
            i++;
            charcode = ((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff);
            utf8.push(0xf0 | (charcode >> 18), 0x80 | ((charcode >> 12) & 0x3f), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
        }
    }
    return utf8;
}
//# sourceMappingURL=Node.js.map